
const STILL_DURATION_MS = 7000

type ClockOwner = 'inline' | 'fullscreen'

type StillClock = {
  elapsedMs: number
  startedAt: number | null
  owner: ClockOwner | null
}

const clocks = new Map<string, StillClock>()

const getClock = (storyId: string): StillClock => {
  let clock = clocks.get(storyId)

  if (!clock) {
    clock = {
      elapsedMs: 0,
      startedAt: null,
      owner: null
    }

    clocks.set(storyId, clock)
  }

  return clock
}

export const getStillElapsedMs = (storyId: string): number => {
  const clock = getClock(storyId)

  const runningMs =
    clock.startedAt === null
      ? 0
      : Math.max(0, performance.now() - clock.startedAt)

  return Math.min(
    STILL_DURATION_MS,
    clock.elapsedMs + runningMs
  )
}

export const resumeStillClock = (
  storyId: string,
  owner: ClockOwner
): void => {
  const clock = getClock(storyId)

  if (clock.owner === owner && clock.startedAt !== null) {
    return
  }

  clock.elapsedMs = getStillElapsedMs(storyId)
  clock.startedAt = performance.now()
  clock.owner = owner
}

export const pauseStillClock = (
  storyId: string,
  owner: ClockOwner
): void => {
  const clock = getClock(storyId)

  // An old owner cannot pause the clock after handoff.
  if (clock.owner !== owner) return

  clock.elapsedMs = getStillElapsedMs(storyId)
  clock.startedAt = null
  clock.owner = null
}

export const resetStillClock = (storyId: string): void => {
  clocks.set(storyId, {
    elapsedMs: 0,
    startedAt: null,
    owner: null
  })
}

export { STILL_DURATION_MS }
